define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 态势标绘类型。
     *
     * @exports EnumPlottingType
     * 
     * @see Plotting#type
     */
    var EnumPlottingType = {
        // /**
        //  * 点。
        //  * @type {String}
        //  * @constant
        //  */
        // POINT: 1,

        /**
         * 折线。
         * @type {String}
         * @constant
         */
        POLYLINE: "POLYLINE",

        /**
         * 多边形。
         * @type {String}
         * @constant
         */
        PT_POLYGON: "PT_POLYGON",

        /**
         * 正N边形。
         * @type {String}
         * @constant
         */
        REGULAR_POLYGON: "REGULAR_POLYGON",

        /**
         * 聚集地。
         * @type {String}
         * @constant
         */
        GATHERING_PLACE: "GATHERING_PLACE",

        /**
         * 曲线表面。
         * @type {String}
         * @constant
         */
        CURVE_SURFACE: "CURVE_SURFACE",

        /**
         * 细直箭头。
         * @type {String}
         * @constant
         */
        STRAIGHT_ARROW: "STRAIGHT_ARROW",

        /**
         * 进攻箭头。
         * @type {String}
         * @constant
         */
        ATTACK_DIRECTION: "ATTACK_DIRECTION",

        /**
         * 进攻箭头（带尾部）。
         * @type {String}
         * @constant
         */
        ATTACK_DIRECTION_TAILED: "ATTACK_DIRECTION_TAILED",

        /**
         * 钳击箭头。
         * @type {String}
         * @constant
         */
        PINCER_ATTACK: "PINCER_ATTACK"

    }
    freezeObject(EnumPlottingType)
    /**
    * 反向查找对齐方式的名称。
    * 
    * @param {String} value 对齐方式的数值。
    * @returns {String} 对齐方式的名称。
    */
    function getName(value) {
        for (var key in EnumPlottingType) {
            if (EnumPlottingType.hasOwnProperty(key) && EnumPlottingType[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        // POINT: 1,
        POLYLINE: "POLYLINE",
        PT_POLYGON: "PT_POLYGON",
        REGULAR_POLYGON: "REGULAR_POLYGON",
        GATHERING_PLACE: "GATHERING_PLACE",
        CURVE_SURFACE: "CURVE_SURFACE",
        STRAIGHT_ARROW: "STRAIGHT_ARROW",
        ATTACK_DIRECTION: "ATTACK_DIRECTION",
        ATTACK_DIRECTION_TAILED: "ATTACK_DIRECTION_TAILED",
        PINCER_ATTACK: "PINCER_ATTACK",
        getName: getName
    }
})